export const reduxFormConstants = {
	feesEditForm: {
		UNLOCK_FIELD: "feesEditForm_UNLOCK_FIELD",
		MERGE_SYNC_ERRORS: "feesEditForm_MERGE_SYNC_ERRORS",
	},
	feeTabsForm: {
		UNLOCK_FIELD: "feeTabsForm_UNLOCK_FIELD",
	},
	"addUser.rolePermissions": {
		SET_PERMISSIONS: "ADD_USER_SET_PERMISSIONS",
	},
	"addUser.merchantLinks": {
		REMOVE_MERCHANT: "ADD_USER_REMOVE_MERCHANT",
	},
	addAgentOfficeForm: {
		REMOVE_RESPONSIBILITIE: "ADD_AGENT_OFFICE_REMOVE_RESPONSIBILITIE",
	},
	editAgentOfficeForm: {
		REMOVE_RESPONSIBILITIE: "EDIT_AGENT_OFFICE_REMOVE_RESPONSIBILITIE",
	},
	"editUser.settings": {
		SET_PERMISSIONS: "EDIT_USER_SETTINGS_SET_PERMISSIONS",
	},
	"editUser.links": {
		REMOVE_MERCHANT: "EDIT_USER_LINKS_REMOVE_MERCHANT",
	},
	"addMerchantUser.rolePermissions": {
		SET_PERMISSIONS: "ADD_MERCHANT_USER_SET_PERMISSIONS",
	},
	"addMerchantUser.merchantLinks": {
		REMOVE_MERCHANT: "ADD_MERCHANT_USER_REMOVE_MERCHANT",
	},
	"editMerchantUser.settings": {
		SET_PERMISSIONS: "EDIT_ADD_MERCHANT_USER_SETTINGS_SET_PERMISSIONS",
	},
	"editMerchantUser.links": {
		REMOVE_MERCHANT: "EDIT_ADD_MERCHANT_USER_LINKS_REMOVE_MERCHANT",
	},
	listOfMerchants: {
		REMOVE_MERCHANT: "ADD_AGENT_LIST_MERCHANT_USER_REMOVE_MERCHANT",
	},
	agentSetupForm:{
		REMOVE_RESPONSIBILITIE: "AGENT_SETUP_REMOVE_RESPONSIBILITIE",
	}
};
